import { AttendanceSubmissionFormData } from "../data/AttendanceSubmissionForm.Data";

export const setAllDropDownFields = (apiResponse, mode) => {
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                });
            }
            return acc;
        }, []);
    }
    let dropdownLists = {
        "statusId": filterDropDownList("Attendance Source"),
    };
   

    const formFields = [
        ...AttendanceSubmissionFormData.formFields
    ];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
    return { ...AttendanceSubmissionFormData, formFields: formFields }
};